import { render, staticRenderFns } from "./ProductHighlightStage.vue?vue&type=template&id=6be80752&"
import script from "./ProductHighlightStage.vue?vue&type=script&lang=js&"
export * from "./ProductHighlightStage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports